function normalizeTextInput(text) {
  // Convert all whitespace to regular space
  text = text.replace(/\s/g, " ");

  // De-duplication of whitespace
  while (text.indexOf("  ") !== -1) {
    text = text.replace(/ {2}/g, " ");
  }

  // Remove space from beginning and end of the text
  text = text.replace(/^ /, "").replace(/ $/, "");

  // Normalize special characters
  text = text.replace(/“/g, '"');
  text = text.replace(/”/g, '"');
  return text;
}

export { normalizeTextInput };
//# sourceMappingURL=util.normalize-input.js.map
